import {fsa, fsaError, fsaPayload} from './helpers'

export const FETCH_PAYPAGE_REGISTRATION_ID_PENDING = 'fetch paypageRegistration ID pending'
export const fetchPaypageRegistrationIdPending = fsa(FETCH_PAYPAGE_REGISTRATION_ID_PENDING)

export const FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS = 'fetch paypageRegistration ID successful'
export const fetchPaypageRegistrationIdSuccess = fsaPayload(FETCH_PAYPAGE_REGISTRATION_ID_SUCCESS)

export const FETCH_PAYPAGE_REGISTRATION_ID_FAILURE = 'fetch pagepageRegistration ID failed'
export const fetchPaypageRegistrationIdFailure = fsaError(FETCH_PAYPAGE_REGISTRATION_ID_FAILURE)

export const HANDLE_WORLDPAY_AUTHORIZATION = 'handle worldpay authorization'
export const handleWorldPayAuthorization = fsaPayload(HANDLE_WORLDPAY_AUTHORIZATION)

export const RESET_VALUES =
  'reset worldpay values to prevent mistakenly charging a previously used card'
export const resetValues = fsa(RESET_VALUES)
